export default __webpack_public_path__ + "media/images/rapport-bleu-b8898185f92244821ed4432253e013e3.png";